import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getNotification } from "../../services/NotificaionAPI";

export const fetchNotificationCount = createAsyncThunk(
  "notifications/fetchNotificationCount",
  async (userId: number) => {
    const payload = {
      recipientUserId: userId,
      priority: "",
      isRead: 0,
      searchString: "",
      triggeredById: userId,
    };
    const response = await getNotification(payload);
    return response.result.length; // return unread count
  }
);

interface NotificationState {
  count: number;
}

const initialState: NotificationState = {
  count: 0,
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotificationCount: (state, action) => {
      state.count = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchNotificationCount.fulfilled, (state, action) => {
      state.count = action.payload;
    });
  },
});

export const { setNotificationCount } = notificationSlice.actions;
export default notificationSlice.reducer;
